


























































































import { Vue, Component } from "vue-property-decorator";
import { ActionSheet, Cell, Dialog } from "vant";

import flightPolicy from "@/service/flightPolicyService"; //getProductInfo
import flight from "@/service/flightService";
import { DurationTime } from "@/utils/utils.ts";
import { forEach, times } from "lodash";
import * as _ from "lodash";
import dataShare from "../dataShare";
@Component({
  components: {
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
  },
  filters: {
    DurationTime,
  },
})
export default class extends Vue {
  //data
  dataShare = dataShare;
  productData: any = {};
  consumerResult: any[] = [];
  reasonShow = false;
  actions = [
    { CategoryID: 1517, name: this.$root.$t("mall_flight_flightchangeinfos_woyaogaibianhangchengbuxiangfeiliao") as string, CategoryCode: "FlightChange", className: "itemClass" },
    { CategoryID: 1518, name: this.$root.$t("mall_flight_flightchangeinfos_jicuohangchengriqishijianxingming") as string, CategoryCode: "FlightMistaken", className: "itemClass" },
    { CategoryID: 1519, name: this.$root.$t("mall_flight_flightchangeinfos_hangbanyanwuhuoquxiao") as string, CategoryCode: "FlightDelay" },
  ];
  reasonVal = this.$root.$t("mall_flight_flightchangeinfos_genjuguisidechalvbiaozhunqingxuanzegaiqianyuanyin") as string;
  isCheckInDate = false;
  DepartDate: Date = new Date();
  ArriveDate: Date = new Date();
  isShowLoading = false;

  get ProductId(): string {
    return (this as any).$route.query.Selected;
  }
  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  get RuleType(): string {
    return (this as any).$route.query.RuleType;
  }
  get changeSource() {
    return dataShare.changeSource;
  }
  get ConsumerData() {
    return JSON.parse((this as any).$route.query.Consumers);
  }
  //mounted
  mounted() {
    (window as any).that = this;
    this.getProductInfo();
  }
  // methods
  getTripNum(number: number) {
    return number == 0 ? this.$root.$t("order_flight_flightdetail_yi") : this.$root.$t("order_flight_flightdetail_er");
  }
  getProductInfo() {
    const data = {
      ProductID: this.ProductId,
    };
    flightPolicy.getProductInfo(data).then(res => {
      if (res.isSucc) {
        this.productData = res.result;
      }
    });
  }
  totalPrice() {
    let price: number = 0;
    _.forEach(this.productData, item => {
      _.forEach(item.Goods, el => {
        _.forEach(el.Prices, o => {
          price += o.SalesPrice;
        });
      });
    });
    return price;
  }
  submitReview() {
    this.isShowLoading = true;
    const query = this.$route.query;
    const data: any = {
      BookingType: query.BookingType,
      ProductID: this.ProductId,
      UniqueID: query.UniqueID,
      // ReasonType: query.ReasonType + "",
      ReasonType: "1517",
      ReasonDetail: "",
      Consumers: this.ConsumerData,
      CreateMode: 1405,
      // ChangeID: this.ChangeID,
      ShoppingID: "",
    };
    if (query.ShoppingID) {
      data.ShoppingID = query.ShoppingID;
    }
    flight.OrderChange(data).then((res: any) => {
      if (res.isSucc) {
        this.isShowLoading = false;
        Dialog.alert({
          message: this.$root.$t("mall_flight_flightchangeinfos_gongxinintijiaochenggongqingnaixindengdaikefuhejia") as string,
          closeOnPopstate: true,
        }).then(() => {
          this.$router.push("/order/myOrder");
        });
      } else {
        this.isShowLoading = false;
        this.$root.$toast(this.$root.$t("mall_flight_flightchangeinfos_dangqiandingdanbukegaiqianqingninzixundianhuakefuxiexie") as string);
      }
    });
  }
  selectChangDate() {
    this.isCheckInDate = true;
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  back(): void {
    history.back();
  }
}
